import _ from 'lodash'
import axios from 'axios'
import Cookies from 'js-cookie'
import { buildQueryStringFromJSON } from 'lib/utils'

// const isLocal = (process.env.REACT_APP_NODE_ENV === 'local' && process.env.REACT_APP_LOCAL_USER && process.env.REACT_APP_LOCAL_USER !== '')
const REST_API_URI = process.env.REACT_APP_REST_API_URI
const INVENTORY_API_URI = process.env.REACT_APP_INVENTORY_API_URI
const WAREHOUSE_API_URI = process.env.REACT_APP_WAREHOUSE_API_URI

function getAccessTokenHeaders() {
  try {
    return { 
      'Authorization': `Bearer ${Cookies.get('token')}`,
    }
  } catch(err) {
    console.log('could not retrieve token and id from localStorage')
    console.error(err)
  }
}

const http = async (endpoint, options, isAuth) => {
  if (isAuth) options.headers =_.extend(options.headers, getAccessTokenHeaders())

  const ops = {
    url: endpoint,
    method: options.method || 'GET',
    data: options.body || {},
    headers: options.headers || { 'Content-Type': 'application/json' },
  };

  ops.headers['X-SimplyBail-App-Id'] = 'PORTAL';
  ops.headers['X-Service-Id'] = process.env.REACT_APP_WAREHOUSE_SERVICE_ID;
  
  try {
    let results = await axios.request(ops);
    if (results && results.status === 200) {
      return results.data
    }
  } catch(error) {
    // Error
    if (error.response) {
      if (error.response.data && error.response.data.message) {
        const { message } = error.response.data
        if (message.indexOf('500 - Token invalid') >= 0) {
          window.localStorage.removeItem('userInfo')
          window.location = '/'
        }
      }
    }
    throw error
  }
};

const get = (endpoint, options = {}, isAuth = false) => {
  return http(REST_API_URI + endpoint, options, isAuth);
};

const put = (endpoint, payload, headers = {}, isAuth = false) => {
  const options = {
    method: 'PUT',
    headers,
    body: JSON.stringify(payload)
  }

  return http(REST_API_URI + endpoint, options, isAuth)
}

const post = (endpoint, payload, headers = {}, isAuth = false) => {
  const options = {
    method: 'POST',
    headers: {
      'Content-Type': 'application/json',
      ...headers,
    },
    body: JSON.stringify(payload),
  };

  return http(REST_API_URI + endpoint, options, isAuth);
};

const remove = (endpoint, payload, headers = {}, isAuth = false) => {
  const options = {
    method: 'DELETE',
    headers,
    body: JSON.stringify(payload)
  }

  return http(REST_API_URI + endpoint, options, isAuth)
}

// Inventory

const getInventory = (endpoint, options = {}, isAuth = false) => {
  return http(INVENTORY_API_URI + endpoint, options, isAuth)
}

const postInventory = (endpoint, payload, headers = {}, isAuth = false) => {
  const options = {
    method: 'POST',
    headers: {
      'Content-Type': 'application/json',
      ...headers,
    },
    body: JSON.stringify(payload)
  }

  return http(INVENTORY_API_URI + endpoint, options, isAuth)
}

const putInventory = (endpoint, payload, headers = {}, isAuth = false) => {
  const options = {
    method: 'PUT',
    headers,
    body: JSON.stringify(payload)
  }

  return http(INVENTORY_API_URI + endpoint, options, isAuth)
}

// Warehouse

const getWarehouse = (endpoint, options = {}, isAuth = false) => {
  options = { ...options,
    headers: { ...options.headers }
  }
  return http(WAREHOUSE_API_URI + endpoint, options, isAuth)
}

const postWarehouse = (endpoint, payload, headers = {}, isAuth = false) => {
  const options = {
    method: 'POST',
    headers: { ...headers },
    body: JSON.stringify(payload)
  }

  return http(WAREHOUSE_API_URI + endpoint, options, isAuth)
}

const putWarehouse = (endpoint, payload, headers = {}, isAuth = false) => {
  const options = {
    method: 'PUT',
    headers: { ...headers },
    body: JSON.stringify(payload)
  }

  return http(WAREHOUSE_API_URI + endpoint, options, isAuth)
}

const agency = {
  fetchAgency: (agencyId) => getInventory(`/agency/${agencyId}`, {}, true),
}

const documents = {
  fetchUserDocuments: token => get(`/document`, { headers: { 'X-User-Token': token } }, false),
  fetchDocumentDetails: (token, params) => post(`/surety/document/details`, params, { 'X-Employee-Token': token }, false)
}

const agencies = {
  all: (suretyId) => get(`/surety/${suretyId}/agencies`, {}, true),
  create: (suretyId, data) => post(`/surety/${suretyId}/agency`, data, {}, true),
  fetch: (suretyId, agencyId) => get(`/surety/${suretyId}/agency/${agencyId}`, {}, true),
  updateRequirements: (suretyId, agencyId, params) => put(`/surety/${suretyId}/agency/${agencyId}/requirements`, params, {}, true),
  updatePermissions: params => put(`/bondsman/permissions`, params, {}, true),
  updatePermissionsEmployees: params => put(`/bondsman/permissions/employees`, params, {}, true),
  updateReviewStatus: (suretyId, agencyId, params) => put(`/surety/${suretyId}/agency/${agencyId}/review-status`, params, {}, true),
  fetchTimeline: (suretyId, agencyId, employeeId) => get(`/surety/${suretyId}/agency/${agencyId}/employee/${employeeId}/chat`, {}, true),
  saveTimelineNote: (suretyId, agencyId, employeeId, params) => post(`/surety/${suretyId}/agency/${agencyId}/employee/${employeeId}/chat`, params, {}, true),
  // deleteTimelineNote: (id, type, params) => remove(`/bondsman/customer/${id}/timeline/${type.toLowerCase()}`, params, {}, true)
}

const files = {
  fetchSignedUrl: (token, params = {}) => post(`/surety/files/upload`, params, { 'X-Employee-Token': token }, false),
  fetchSecureUrls: (token, params) => post(`/surety/files/upload/urls`, params, { 'X-Employee-Token': token }, false),
  uploadComplete: (token, params) => post(`/surety/files/upload/complete`, params, { 'X-Employee-Token': token }, false)
}

const employees = {
  all: (query = null) => get(`/employees${query ? query : ''}`, {}, true),
  createEmployee: data => post(`/employee`, data, {}, true),
  updateEmployee: (id, data) => put(`/employee/${id}`, data, {}, true),
  resetEmployee: (id) => put(`/employee/${id}/reset`, {}, {}, true),
  deleteEmployee: (id) => remove(`/employee/${id}`, {}, {}, true),
  fetchEmployeeByToken: token => get(`/employee/token/verify`, { headers: { 'X-Reset-Token': token } }, false),
  resetPassword: (token, data) => put(`/employee/password-reset`, data, { 'X-Reset-Token': token }, false)
}

const inventory = {
  receiptCode: (params) => putInventory(`/receipt`, params, {}, false),
  verifyPowerDetails: (powerId, params = {}) => postInventory(`/power/${powerId}`, params, {}, false),
  getDownload: (downloadId) => getInventory(`/download/${downloadId}`, {}, false),
  getTransfer: (transferId) => getInventory(`/transfer/${transferId}/posting`, {}, false),
  updateTransferPowerProof: (transferId, powerId, data) => putInventory(`/transfer/${transferId}/power/${powerId}/power-proof`, data, {}, false),
  generateTransferDocument: (transferId, data) => postInventory(`/transfer/${transferId}/document`, data, {}, false),
  createPublicSignedUrl: (transferId, params) => postInventory(`/transfer/${transferId}/signed-url`, params, {}, false),
  download: (downloadId, isSummaryOnly, params = null) => postInventory(`/download/${downloadId}/code?isSummaryOnly=${isSummaryOnly}`, params, {}, false),
  syncEmployees: (agencyId, params) => postInventory(`/agency/${agencyId}/employees/sync`, params, {}, true),
  fetchPackages: (agencyId) => getInventory(`/agency/${agencyId}/packages`, {}, true),
  fetchTransfers: (agencyId) => getInventory(`/agency/${agencyId}/transfers`, {}, true),
  fetchPackageById: (agencyId, packageId) => getInventory(`/agency/${agencyId}/package/${packageId}`, {}, true),
  takeOwnership: (agencyId, transferId, params) => putInventory(`/agency/${agencyId}/transfer/${transferId}/claim`, params, {}, true),
}

const powers = {
  fetchPowers: (agencyId, options = null) => getInventory(`/portal/agency/${agencyId}/powers${options ? buildQueryStringFromJSON(options) : ''}`, {}, true),
  generatePowerTransferSheet: (agencyId, transferId, params) => post(`/agency/${agencyId}/transfer/${transferId}`, params, {}, true),
  updatePower: (agencyId, powerId, params) => putInventory(`/agency/${agencyId}/power/${powerId}/power`, params, {}, true),
  generatePower: (params) => post(`/power/generate`, params, {}, true),
}

const reports = {
  fetchPowerProofReport: (reportId) => getInventory(`/portal/report/${reportId}/powers`, {}, false),
  updatePowerProof: (reportId, powerId, data) => putInventory(`/portal/report/${reportId}/power/${powerId}/power-proof`, data, {}, false),
  fetchReports: () => getInventory(`/reports`, {}, true),
  createReport: (agencyId, params) => postInventory(`/portal/agency/${agencyId}/report`, params, {}, true),
  fetchReport: (agencyId, reportId) => getInventory(`/surety/${agencyId}/report/${reportId}`, {}, true),
  updateReport: (agencyId, reportId, params) => putInventory(`/surety/${agencyId}/report/${reportId}`, params, {}, true),
  updateReportStatus: (agencyId, reportId, status) => putInventory(`/portal/agency/${agencyId}/report/${reportId}/status`, { status }, {}, true),
  addPowerToReport: (agencyId, reportId, params) => postInventory(`/portal/agency/${agencyId}/report/${reportId}/power`, params, {}, true),
}

const warehouse = {
  buildAnswerGroupToken: token => postWarehouse(`/token/${token}`, {}, {}, false),
  fetchAnswerGroup: (token, jwt) => getWarehouse(`/token/${token}`, { headers: { 'X-Answer-Token': jwt } }),
  fetchAnswerGroupRequests: (token, jwt) => getWarehouse(`/token/${token}/requests`, { headers: { 'X-Answer-Token': jwt } }),
  fetchNextQuestion: (token, jwt) => getWarehouse(`/token/${token}/question`, { headers: { 'X-Answer-Token': jwt } }),
  answerQuestion: (token, questionId, params, jwt) => postWarehouse(`/token/${token}/question/${questionId}`, params, { 'X-Answer-Token': jwt }),
  fetchDocumentRequest: (token, requestId, jwt) => postWarehouse(`/token/${token}/request/${requestId}?bypass=true`, {}, { 'X-Answer-Token': jwt }),
  markRequestComplete: (token, params, jwt) => putWarehouse(`/token/${token}/request/complete`, params, { 'X-Answer-Token': jwt }),
}

const users = {
  auth: ({ token }) => post(`/surety/auth`, {}, { 'Authorization': 'Bearer ' + token }, false),
  fetchProfile: () => get('/surety/profile', {}, true),
  fetchToken: params => post('/auth/token', params, {}, false)
}

let api = {
  agencies,
  agency,
  documents,
  files,
  employees,
  inventory,
  powers,
  reports,
  warehouse,
  users
};

export default api;
